module.exports = __webpack_public_path__ + "static/thread.91e918d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/illustrations/thread.png
// module id = 466
// module chunks = 35783957827783